var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourier6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9423 0.852817C29.6303 2.55175 28.8042 5.11822 25.4282 8.51608L24.1352 9.78124L25.4282 23.8426L22.8782 26.4091L17.7782 16.1793L12.7141 21.3123V26.4091L10.1641 28.9755L7.65 21.3123L0 18.7458L2.55 16.1793H7.65L12.7141 11.0826L2.55 5.94961L5.1 3.41929L19.0711 4.68445L20.3282 3.41929C23.7042 -0.0147221 26.2542 -0.846114 27.9423 0.852817ZM23.0577 49.1458C21.3697 47.4469 22.1958 44.8804 25.6077 41.4826L26.8648 40.2174L25.6077 26.156L28.1218 23.5896L33.2218 33.8193L38.2859 28.7225V23.5896L40.8359 21.0231L43.3859 28.7225L51 31.2528L48.45 33.8193H43.3859L38.2859 38.9161L48.45 44.049L45.9 46.6155L31.9289 45.3142L30.6718 46.6155C27.2958 50.0134 24.7458 50.8448 23.0577 49.1458Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourier6);
export default __webpack_public_path__ + "static/media/courier6.62d186c9af0a15f312d45ac0d73b0b7f.svg";
export { ForwardRef as ReactComponent };